/* global PLATFORM */
import settings from '@tenant/settings'
import { asyncPipeSpread } from 'lib/util'
import { hide, show } from 'lib/sequence/component/state/hidden'
import find from 'lib/sequence/component/children/find'

/**
 * Toggles the display of the home banners according to the `showHomeBanner` setting.
 *
 * @param {Gaia.AppModule.Spec} module current module
 * @return {function(*, ...[*]): *[]}
 */
const displayCustomElements = module => (components, ...args) => {
  const { headerBanner, welcomeBanner, reqApmGo, fseApmGo, scan } = components
  const { showHomeBanner, showApmGo, suppressScanButton } = settings

  showHomeBanner
    && (PLATFORM === 'mobile' ? show(headerBanner) : show(welcomeBanner))

  scan && suppressScanButton && hide(scan)
  showApmGo && show(reqApmGo) && show(fseApmGo)

  return [components, ...args]
}

/**
 * EquipmentInformation Equipment Action
 *
 * @param {Gaia.AppModule.Spec} module current module
 * @returns {function(*): function(...[*]): Promise<*[]>}
 */
export default module => component => async (...args) => asyncPipeSpread(
  displayCustomElements(module),
  (components, ...rest) => args,
)(find(component), ...args)
